import Swiper from "swiper";
import { A11y, Autoplay, Navigation, Pagination } from "swiper/modules";

export default class Sliders {
    constructor(slider, index) {
        this.slider = slider;
        this.index = index;
        this.slides = Array.from(this.slider.querySelectorAll(".swiper-slide"));
        this.lastSlideIndex = null; // Track last active slide index

        this.options = this.setOptions();
        this.initSlider();
    }

    setOptions() {
        let options = {};

        // Towels carousel options
        if (this.slider.classList.contains('swiper--towels')) {
            options = {
                modules: [A11y, Autoplay],
                spaceBetween: 60,
                height: 100,
                updateOnWindowResize: true,
                watchOverflow: true,
                centeredSlides: false,
                slidesPerView: 3,
                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                        spaceBetween: 40,
                    },
                    768: {
                        slidesPerView: 2.2,
                        spaceBetween: 45,
                    },
                    992: {
                        slidesPerView: 3.2,
                        spaceBetween: 50,
                    },
                    1680: {
                        slidesPerView: 4.2,
                        spaceBetween: 60,
                    }
                },
                a11y: {
                    enabled: true,
                    containerRole: 'region',
                    containerRoleDescriptionMessage: 'carousel',
                    containerMessage: 'Towels carousel',
                    prevSlideMessage: 'Previous slide',
                    nextSlideMessage: 'Next slide',
                    paginationBulletMessage: 'Go to slide {{index}}',
                    itemRoleDescriptionMessage: 'slide',
                },
            }
        }

        return options;
    }

    initSlider() {
        this.swiperInstance = new Swiper(this.slider, this.options);
    }

    destroy() {
        if (this.swiperInstance) {
            this.swiperInstance.destroy();
        }
    }

    static destroyAll() {
        Sliders.items.forEach((slider) => {
            slider.destroy();
        });
    }

    static init() {
        Sliders.items = Array.from(document.querySelectorAll(".swiper")).map(
            (slider, index) => new Sliders(slider, index),
        );
    }
}
